import { Component } from '@angular/core';

@Component({
    templateUrl: '404.component.html',
    standalone: false
})
export class P404Component {

  constructor() { }

}
